export default "__VITE_ASSET__BOG0Kyq5__"